// extracted by mini-css-extract-plugin
module.exports = {"unusedCarouselSpace":"92px","FacetImage":"_2Sg79D","facetText":"_3qC00w","primeFacet":"IxOgRT","fadeInFrames":"h3-174"};